import type { GroupedQuotes } from '../types'
import type { TransferTime } from '../helpers/transfer-time'

export function getBestTransferTime(provider: GroupedQuotes) {
  let bestTime = Number.MAX_SAFE_INTEGER
  let best: TransferTime | undefined
  for (const { transferTime } of provider.services) {
    const time = (transferTime.min + transferTime.max) / 2
    if (time < bestTime) {
      bestTime = time
      best = transferTime
    }
  }
  if (best) {
    const { id, min, max } = best
    return { id, min, max }
  }
}
